import React from 'react';
import PinboardBlock from '../components/c-pinboard';
export default (props) => (
  <PinboardBlock
    {...props}
    Theme={props.Theme}
    Async={props.Theme === 'random'}
  />
);
